import React from "react";
import { BsMusicNoteList } from "react-icons/bs";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction";
import { Link } from "react-router-dom";
import { MdOutlineCategory } from "react-icons/md";
import { CiTimer } from "react-icons/ci";
import { Badge } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const playlistCard = ({ item }) => {
  const { t } = useTranslation();
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );
  const dispatch = useDispatch();
  return (
    <div className="top_songs_list free_music_wrapper ms_cover">
      <div style={{ width: "100%" }} className="top_songs_list_left">
        <div className="trea  <div>playlistCard</div>nding_slider_main_box top_lis_left_content">
          <div className="playlistcardWrapContainer">
            <div style={{ height: "100%" }} className="top_songs_list0img">
              <img
                src={item.picture}
                style={{
                  height: "100%",
                  maxHeight: "180px",
                  maxWidth: "350px",
                  width: "100%",
                  objectFit: "cover",
                }}
                alt="img"
              />
              <div
                style={{ paddingLeft: "55px" }}
                className="ms_treanding_box_overlay"
              >
                <div className="tranding_play_icon">
                  {PlayerFrontOfficeReducer?.currentSong === item.file_path ? (
                    <BsMusicNoteList size={20} />
                  ) : (
                    <a
                      onClick={() =>
                        dispatch(
                          addMusic({
                            currentsong: item.file_path,
                            namesong: `${item.name}`,
                            item_data: item,
                            is_web_rtc: false,
                            has_video:
                              item.media?.filter((el) => el.media_type_id === 3)
                                ?.length > 0
                                ? true
                                : false,
                            songimg: item.picture,
                          })
                        )
                      }
                    >
                      <i className="flaticon-play-button" />
                    </a>
                  )}
                </div>
              </div>
            </div>

            <div
              style={{ minWidth: "150px" }}
              className="release_content_artist top_list_content_artist"
            >
              <p>
                <Link to={`/playlist/${item.id}`}>{item.name}</Link>
              </p>
              <p className="various_artist_text">
                <a>
                  {t("Media count")}: {item.media_count}{" "}
                </a>
              </p>
              <span
                style={{
                  display: "flex",
                  alignContent: "center",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  marginTop: "15px",
                }}
              >
                <span
                  style={{
                    display: "flex",
                    alignContent: "center",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      flexWrap: "nowrap",
                    }}
                  >
                    <p style={{ fontSize: "15px" }}>
                      <CiTimer style={{ fontSize: "15px" }} /> duration
                    </p>
                  </span>

                  <p style={{ fontSize: "15px", marginLeft: "5px" }}>
                    {item.playtime_string}
                  </p>
                </span>
              </span>
              <span
                style={{
                  display: "flex",
                  alignContent: "center",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <span
                  style={{
                    display: "flex",
                    alignContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flexWrap: "nowrap",
                  }}
                >
                  <p style={{ fontSize: "15px" }}>
                    <MdOutlineCategory style={{ fontSize: "15px" }} />{" "}
                    categories
                  </p>
                </span>

                <span
                  style={{
                    marginLeft: "5px",
                    display: "flex",
                    alignContent: "center",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  {item.categories?.map((ele, j) => (
                    <Link
                      key={`playlist_category_item$${j}`}
                      to={`/playlists/category/${ele.id}`}
                    >
                      <Badge style={{ margin: "2px" }} color="light-warning">
                        {ele.name}
                      </Badge>
                    </Link>
                  ))}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default playlistCard;
